import { render, staticRenderFns } from "./scores.vue?vue&type=template&id=ae0698f6&scoped=true&"
import script from "./scores.vue?vue&type=script&lang=js&"
export * from "./scores.vue?vue&type=script&lang=js&"
import style0 from "./scores.vue?vue&type=style&index=0&id=ae0698f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0698f6",
  null
  
)

export default component.exports